import { render, staticRenderFns } from "./DisplayBoard.vue?vue&type=template&id=ecffb76a"
import script from "./DisplayBoard.vue?vue&type=script&lang=js"
export * from "./DisplayBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports